//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { RepertoireUpdateItem } from './RepertoireUpdateItem';

export class BatchRepertoireUpdateItem extends RepertoireUpdateItem {
    RepertoireID: string | null = null;

    constructor(initializer?: Partial<BatchRepertoireUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "BatchRepertoireUpdateItem";
}
